<template>
    <ul class="list-unstyled" style="margin: 0; padding: 0">
        <li v-for="(string, index1) in description" :key="index1">
            <template v-for="(item, index2) in string.text">
                <span :key="index2" class="pr-1 pl-1 bg-primary text-white print"
                      v-if="item.indexOf('summ') + 1">{{ item.replace('summ', '₸') }}</span>
                <span :key="index2" class="pr-1 pl-1 bg-danger text-white print"
                      v-else-if="item.indexOf('mrp') + 1">{{ item.replace('mrp', 'МРП') }}</span>
                <span :key="index2" class="pr-1 pl-1 bg-danger text-white print"
                      v-else-if="item.indexOf('mzp') + 1">{{ item.replace('mrp', 'МЗП') }}</span>
                <span :key="index2" class="pr-1 pl-1 bg-danger text-white print"
                      v-else-if="item.indexOf('percent') + 1">{{ item.replace('percent', '%') }}</span>
                <span :key="index2" class="pr-1 pl-1 bg-secondary text-white print"
                      v-else-if="item.indexOf('description') + 1">{{ item.replace('description', '') }}</span>
                <span :key="index2" class="pr-1 pl-1" v-else>{{ item }}</span>

            </template>
            <template v-if="typeof string.adjustment != 'undefined'">
                <!--<span class="badge badge-default">Примечания:</span>-->
                <span v-if="typeof string.adjustment != 'undefined' && string.adjustment" class="pr-1 pl-1 bg-warning text-white print"
                      v-b-tooltip.hover title="Участвует в расчете корр./обл.дохода 90%">Участвует в расчете корректировки/облагаемого дохода 90%</span>
                <span v-if="typeof string.adjustment != 'undefined' && !string.adjustment" class="pr-1 pl-1 bg-warning text-white print"
                      v-b-tooltip.hover title="НЕ участвует в расчете корр./обл.дохода 90%">Не участвует в расчете корректировки/облагаемого дохода 90%</span>
            </template>
        </li>

    </ul>

</template>

<script>

export default {
    name: 'SalaryDescription',
    props: ['description'],
    methods: {
        ReplaceBadge: function (text) {

            text = text.replace('[', '<span class="badge badge-primary">');
            text = text.replace(']', '</span>');
            return text;
        }
    }

}
</script>

<style>

</style>